/**
 * How wide a Carousel's slides are, by what they hold, at each breakpoint: complete class literals,
 * so Tailwind sees them. Each step is a whole number of slides per view less the track's 16px gaps,
 * except on phones, where a share of the width leaves the next slide peeking.
 */
export const CAROUSEL_SLIDES = {
  /** Most of the width on phones, about two on sm and three from lg: features, promos. */
  wide: "basis-[82%] sm:basis-[calc((100%-16px)/2)] lg:basis-[calc((100%-32px)/3)]",
  /** Box tiles: a little under half on phones, then three, four, five and six. */
  tiles:
    "basis-[44%] sm:basis-[calc((100%-32px)/3)] md:basis-[calc((100%-48px)/4)] lg:basis-[calc((100%-64px)/5)] xl:basis-[calc((100%-80px)/6)]",
  /** Pull cards: a little under half on phones, then four, five, seven and eight. */
  cards:
    "basis-[40%] sm:basis-[calc((100%-48px)/4)] md:basis-[calc((100%-64px)/5)] lg:basis-[calc((100%-96px)/7)] xl:basis-[calc((100%-112px)/8)]",
} as const;
